<template>
  <div class="dialog-invoice">
    <el-dialog :title="isAdd?'新增':'修改'+'发票信息'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="cancleInvoiceDialog"
      width="560px" >
      <div>
        <el-form :model="invoiceDialogForm" label-width="150px" :rules="invoiceDialogForm.defaultInvoiceType===0?generalRules:rules" ref="invoiceForm">
          <el-form-item label="抬头类型：" prop="titleType">
            <el-radio-group v-model="invoiceDialogForm.titleType" @change="titleTypeChangeFn">
              <el-radio :label="0">个人</el-radio>
              <el-radio :label="1" v-if="user.role===2">企业</el-radio>
              <!-- <el-radio :label="2">事业单位</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票抬头：" prop="title">
            <el-input v-model="invoiceDialogForm.title" placeholder="请输入发票抬头" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item label="默认发票类型：" prop="defaultInvoiceType">
            <el-radio-group v-model="invoiceDialogForm.defaultInvoiceType" @change="defaultInvoiceTypeChangeFn">
              <el-radio :label="0">
                增值税普通发票
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="width: 360px;">增值税普通发票开给小规模纳税人或者开票资料不齐全的购买人，购买人取得后不可以进行进项税额抵扣。若您还有疑问，建议联系贵公司财务确认后再提交开票需求。</div>
                  <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                </el-tooltip>
              </el-radio>
              <!-- 个人不能开专用发票 -->
              <el-radio :label="1" :disabled="invoiceDialogForm.titleType === 0">
                增值税专用发票
                 <el-tooltip placement="top" effect="light">
                  <div slot="content" style="width: 360px;">增值税专用发票开给一般纳税人，申请时需要提供公司名称、税号、地址电话、开户行名称及账号，一般纳税人批复，购买人取得后可以进行进项税额抵扣。增值税专用发票只能开具纸质发票。
若您还有疑问，建议联系贵公司财务确认后再提交开票需求。
                  </div>
                  <img class="question-icon" :src="$baseUrl+'img/question.png'" alt="">
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="统一社会信用代码：" prop="creditCode">
            <el-input v-model="invoiceDialogForm.creditCode" placeholder="请输入统一社会信用代码" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item v-if="user.role===2" label="开户银行名称：" prop="bankName">
            <el-input v-model="invoiceDialogForm.bankName" placeholder="请输入开户银行名称" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item v-if="user.role===2" label="基本开户账号：" prop="bankAccount">
            <el-input v-model="invoiceDialogForm.bankAccount" placeholder="请输入基本开户账号" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item v-if="user.role===2" label="注册场所地址：" prop="registPlaceAddress">
            <el-input v-model="invoiceDialogForm.registPlaceAddress" placeholder="请输入注册场所地址" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item v-if="user.role===2" label="注册固定电话：" prop="registFixedPhone">
            <el-input v-model="invoiceDialogForm.registFixedPhone" placeholder="请输入注册固定电话" size="small" class="pxy-input"></el-input>
          </el-form-item>
          <el-form-item v-if="user.role===2" label="一般纳税人资质：" prop="taxpayerQualification">
            <PicUpload :picUrl="invoiceDialogForm.taxpayerQualification" @getUrl="taxpayerQualificationFn" />
          </el-form-item>
          <el-form-item v-if="user.role===2" label="营业执照复印件：" prop="businessLicense">
            <PicUpload :picUrl="invoiceDialogForm.businessLicense" @getUrl="businessLicenseFn" />
          </el-form-item>
          <el-form-item v-if="user.role===2" label="开户许可证：" prop="accountOpeningPermit">
            <PicUpload :picUrl="invoiceDialogForm.accountOpeningPermit" @getUrl="accountOpeningPermitFn" />
          </el-form-item>
          <el-form-item v-if="user.role===2" label="开专票信息：" prop="specialTicketInfo">
            <PicUpload :picUrl="invoiceDialogForm.specialTicketInfo" @getUrl="specialTicketInfoFn" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleInvoiceDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" v-loading="loading" :disabled="loading" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PicUpload from "./picUpload.vue"
const validateTelphone = (rule, value,callback) => {
  const reg =/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,4}))?$/;
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的固定电话'));
    }
  }
export default {
  props:['dialogVisibleProps','isAdd','invoiceFormProps'],
  components: { PicUpload },
  data() {
    return {
      loading: false,
      invoiceDialogForm: {
        titleType: 0, //抬头类型
        title: '', //发票抬头
        defaultInvoiceType: 0, //默认发票类型
        creditCode: '', // 统一社会信用代码
        bankName: '', //开户银行名称
        bankAccount: '', // 基本开户账号
        registPlaceAddress: '', // 注册场所地址
        registFixedPhone: '', // 注册固定电话
        taxpayerQualification: '', // 一般纳税人资质
        businessLicense: '', // 营业执照复印件
        accountOpeningPermit: '', //开户许可证
        specialTicketInfo: '', // 开专票信息
      },
      generalRules: {
        creditCode: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
        title: [{required: true, message: '请输入发票抬头', trigger: 'blur'}],
      },
      rules: {
        titleType: [{required: true, message: '请选择抬头类型', trigger: 'change'}],
        title: [{required: true, message: '请输入发票抬头', trigger: 'blur'}],
        defaultInvoiceType: [{required: true, message: '请选择默认发票类型', trigger: 'blur'}],
        creditCode: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
        bankName: [{required: true, message: '请输入开户银行名称', trigger: 'blur'}],
        bankAccount: [{required: true, message: '请输入基本开户账号', trigger: 'blur'}],
        registPlaceAddress: [{required: true, message: '请输入注册场所地址', trigger: 'blur'}],
        registFixedPhone: [
          {required: true, message: '请输入注册固定电话', trigger: 'blur'},
          {validator: validateTelphone, trigger: 'blur'},
        ],
        taxpayerQualification: [{required: true, message: '请上传一般纳税人资质图片', trigger: 'change,blur'}],
        businessLicense: [{required: true, message: '请上传营业执照复印件', trigger: 'change,blur'}],
        accountOpeningPermit: [{required: true, message: '请上传开户许可证', trigger: 'change,blur'}],
        specialTicketInfo: [{required: true, message: '请上传开专票信息', trigger: 'change,blur'}],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    dialogVisible: {
      get() {
        return this.dialogVisibleProps;
      },
      set() {}
    }
  },
  watch: {
    'invoiceFormProps': {
      handler(val) {
        this.invoiceDialogForm = Object.assign(this.invoiceDialogForm, val);
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if(this.user.role === 2) { // 企业
      this.invoiceDialogForm.titleType = 1;
    } else if(this.user.role === 1) { // 个人
      this.invoiceDialogForm.titleType = 0;
    }
  },
  methods: {
    submit() {
      this.$refs.invoiceForm.validate(valid => {
        if(valid) {
          // console.log(this.invoiceDialogForm)
          let url = this.isAdd?'/ofc/invoiceInfo/add' :'/ofc/invoiceInfo/update';
          let params = Object.assign(this.invoiceDialogForm,{userId: this.user.userId});
          this.loading = true;
          this.postRequestJson(url, params).then(res => {
            this.loading = false;
            if(res.status === 200) {
              if(res.data.code === 1000) {
                 this.$message.success('保存成功！');
                this.cancleInvoiceDialog('addAfter');
                this.$refs.invoiceForm.resetFields();
                this.$refs.invoiceForm.clearValidate();
              } else {
                this.$message.error(res.data.message);
              }
            }
          })
        }
      })
    },
    // 一般纳税人资质
    taxpayerQualificationFn(val) {
      this.invoiceDialogForm.taxpayerQualification = val;
    },
    // 营业执照复印件
    businessLicenseFn(val) {
      this.invoiceDialogForm.businessLicense = val;
    },
    // 开户许可证
    accountOpeningPermitFn(val) {
      this.invoiceDialogForm.accountOpeningPermit = val;
    },
    // 开专票信息
    specialTicketInfoFn(val) {
      this.invoiceDialogForm.specialTicketInfo = val;
    },
    // 抬头类型更改，个人不能开专用发票
    titleTypeChangeFn(val) {
      if(val === 0) {
        this.invoiceDialogForm.defaultInvoiceType = '';
      }
    },
    // 默认发票类型更改
    defaultInvoiceTypeChangeFn(val) {
      if(val === 0) {
        this.$refs.invoiceForm.clearValidate();
      }
    },
    // 取消
    cancleInvoiceDialog(val) {
      this.$refs.invoiceForm.clearValidate();
      if(val) {
        this.$emit('cancleInvoiceDialog',val);
      } else {
        this.$emit('cancleInvoiceDialog');
      }
    }
  }
}
</script>
<style lang='scss' scoped>
  .dialog-invoice{
    .pxy-input {
      width: 220px;
    }
  }
 </style>
